"use strict";
import { skipToken, useQuery } from "@tanstack/react-query";
import { uniswapUrls } from "constants/urls";
import { is404Error } from "data/apiClients/FetchError";
import { SharedQueryClient } from "data/apiClients/SharedQueryClient";
import { fetchIndicativeQuote } from "data/apiClients/tradingApi/TradingApiClient";
import { logSwapQuoteFetch } from "features/transactions/swap/analytics";
import { ReactQueryCacheKey } from "utilities/src/reactQuery/cache";
function getTradingApiIndicativeQuoteQueryKey(params) {
  return [ReactQueryCacheKey.TradingApi, uniswapUrls.tradingApiPaths.indicativeQuote, params];
}
export function useTradingApiIndicativeQuoteQuery({
  params,
  ...rest
}) {
  const queryKey = getTradingApiIndicativeQuoteQueryKey(params);
  return useQuery({
    queryKey,
    queryFn: params ? async () => {
      if (params.tokenInChainId) {
        logSwapQuoteFetch({ chainId: params.tokenInChainId, isQuickRoute: true });
      }
      return await fetchIndicativeQuote(params);
    } : skipToken,
    ...rest
  });
}
export async function fetchTradingApiIndicativeQuoteIgnoring404({
  queryClient = SharedQueryClient,
  params
}) {
  try {
    return await queryClient.fetchQuery({
      queryKey: getTradingApiIndicativeQuoteQueryKey(params),
      queryFn: async () => fetchIndicativeQuote(params)
    });
  } catch (error) {
    if (is404Error(error)) {
      return void 0;
    }
    throw error;
  }
}
